import { INBOUND_TYPE } from "@erp/shared/types/inbound-type.types";
import { STOCK_APPROVAL_PHASE } from "@erp/shared/types/stock-approval-phase.types";
export const mockOrderInboundProduct = [
    {
        id: 2,
        orderId: 1,
        projectCode: "AP-123.",
        type: "원부자재",
        classification: "전력기기-B",
        productCode: "PE-B-0002",
        name: "Resistor",
        purchaseNum: "3",
        spec: "DC-Link Voltage Divider, PR100 1M 5%",
        model: "0",
        manufacturer: "ATE",
        unitPrice: 18500,
        inbounds: [
            {
                id: 1,
                inboundId: 1,
                orderId: 1,
                addData: INBOUND_TYPE.발주내역,
                type: "원부자재",
                classification: "전력기기-B",
                productCode: "임의 제품 코드",
                name: "임의 제품",
                num: 3,
                spec: "DC-Link Voltage Divider, PR100 1M 5%",
                model: "0",
                manufacturer: "ATE",
                unitPrice: 18500,
                shipCode: "임의 출고 코드",
            },
            {
                id: 2,
                inboundId: 2,
                orderId: 1,
                addData: INBOUND_TYPE.발주내역,
                type: "원부자재 2",
                classification: "전력기기-C",
                productCode: "임의 제품 코드 2",
                name: "임의 제품 2",
                num: 3,
                spec: "DC-Link Voltage Divider, PR100 1M 5%",
                model: "0",
                manufacturer: "ATE",
                unitPrice: 18500,
                shipCode: "임의 출고 코드 2",
            },
        ],
    },
];
export const mockInboundSearchConfirm = [
    {
        id: 1,
        addData: INBOUND_TYPE.발주내역,
        approvalPhase: STOCK_APPROVAL_PHASE.승인,
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        createdTime: "2024-01-15T08:00:00Z",
        checker: 119,
        checkerId: "mbj",
        checkerName: "문병준",
        checkedDate: "2024-01-15T09:30:00Z",
        approver: 120,
        approverId: "ehj",
        approverName: "엄현준",
        approvedDate: "2024-01-15T14:20:00Z",
        rejecter: null,
        rejecterId: null,
        rejecterName: null,
        rejectedDate: null,
        rejectReason: null,
        inboundDate: "2024-01-16T10:00:00Z",
        purchaseManager: 104,
        purchaseManagerId: "user004",
        purchaseManagerName: "정수진",
        materialManager: 105,
        materialManagerId: "user005",
        materialManagerName: "최동훈",
        abnormalReason: "",
        note: "정상 입고 완료",
        projectCode: "PRJ-2024-001",
        receivingInspectionFile: null,
        inspectionReportFile: "inspection_report_001.pdf",
        etcFiles: ["receipt_001.pdf", "warranty_001.pdf"],
    },
    {
        id: 2,
        addData: INBOUND_TYPE.자재선택,
        approvalPhase: STOCK_APPROVAL_PHASE.미승인,
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        createdTime: "2024-01-17T09:00:00Z",
        checker: 119,
        checkerId: "mbj",
        checkerName: "문병준",
        checkedDate: null,
        approver: 119,
        approverId: "mbj",
        approverName: "문병준",
        approvedDate: null,
        rejecter: null,
        rejecterId: null,
        rejecterName: null,
        rejectedDate: null,
        rejectReason: null,
        inboundDate: "2024-01-17T11:30:00Z",
        purchaseManager: null,
        purchaseManagerId: null,
        purchaseManagerName: null,
        materialManager: 107,
        materialManagerId: "user007",
        materialManagerName: "윤태호",
        abnormalReason: "",
        note: "직접 입력된 자재",
        projectCode: "PRJ-2024-002",
        receivingInspectionFile: null,
        inspectionReportFile: null,
        etcFiles: null,
    },
    {
        id: 3,
        addData: INBOUND_TYPE.자재선택,
        approvalPhase: STOCK_APPROVAL_PHASE.반려,
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        createdTime: "2024-01-18T08:00:00Z",
        checker: 119,
        checkerId: "mbj",
        checkerName: "문병준",
        checkedDate: "2024-01-18T08:45:00Z",
        approver: 0,
        approverId: "",
        approverName: "",
        approvedDate: null,
        rejecter: 110,
        rejecterId: "user010",
        rejecterName: "임소영",
        rejectedDate: "2024-01-18T16:30:00Z",
        rejectReason: "자재 사양이 일치하지 않음",
        inboundDate: "2024-01-18T13:15:00Z",
        purchaseManager: 111,
        purchaseManagerId: "user011",
        purchaseManagerName: "조현우",
        materialManager: 112,
        materialManagerId: "user012",
        materialManagerName: "배수정",
        abnormalReason: "사양 불일치",
        note: "반려 처리됨",
        projectCode: "PRJ-2024-003",
        receivingInspectionFile: null,
        inspectionReportFile: "inspection_report_003.pdf",
        etcFiles: ["rejection_reason_003.pdf"],
    },
    {
        id: 4,
        addData: INBOUND_TYPE.출고내역,
        approvalPhase: STOCK_APPROVAL_PHASE.미확인,
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        createdTime: "2024-01-19T09:00:00Z",
        checker: 119,
        checkerId: "mbj",
        checkerName: "문병준",
        checkedDate: null,
        approver: 120,
        approverId: "ehj",
        approverName: "엄현준",
        approvedDate: null,
        rejecter: null,
        rejecterId: null,
        rejecterName: null,
        rejectedDate: null,
        rejectReason: null,
        inboundDate: "2024-01-19T14:45:00Z",
        purchaseManager: null,
        purchaseManagerId: null,
        purchaseManagerName: null,
        materialManager: 115,
        materialManagerId: "user015",
        materialManagerName: "이상민",
        abnormalReason: "",
        note: "재입고 처리 중",
        projectCode: "PRJ-2024-004",
        receivingInspectionFile: null,
        inspectionReportFile: null,
        etcFiles: ["rework_plan_004.pdf"],
    },
    {
        id: 5,
        addData: INBOUND_TYPE.발주내역,
        approvalPhase: STOCK_APPROVAL_PHASE.미승인,
        creater: 116,
        createrId: "user016",
        createrName: "장미래",
        createdTime: "2024-01-20T08:30:00Z",
        checker: 117,
        checkerId: "user017",
        checkerName: "서동현",
        checkedDate: "2024-01-20T09:15:00Z",
        approver: 0,
        approverId: "",
        approverName: "",
        approvedDate: null,
        rejecter: null,
        rejecterId: null,
        rejecterName: null,
        rejectedDate: null,
        rejectReason: null,
        inboundDate: "2024-01-20T11:00:00Z",
        purchaseManager: 118,
        purchaseManagerId: "user018",
        purchaseManagerName: "노지훈",
        materialManager: 123,
        materialManagerId: "user019",
        materialManagerName: "신예린",
        abnormalReason: "",
        note: "승인 대기 중",
        projectCode: "PRJ-2024-005",
        receivingInspectionFile: null,
        inspectionReportFile: null,
        etcFiles: ["approval_request_005.pdf"],
    },
];
